import { network } from "../network/network.js";
export async function uploadFile(file) {
    const formData = new FormData();
    formData.append("file", file);
    return await network("/files", { method: "POST", body: formData });
}
export async function deleteFile(id) {
    await network(`/files/${id}`, { method: "DELETE" });
}
export async function searchFiles(query) {
    return await network("/files", { query });
}
